import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import {
  Typography,
  Grid,
  Link,
  Button,
  Box,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import {
  loginValidationSchema,
  loginInitialState,
  loginModel,
} from 'forms/login';
import BankLogo from 'assets/img/BankLogo.png';
import { login } from 'redux/slices/authSlice';
import { authSelector } from 'redux/selectors';

const useStyles = makeStyles((theme) => ({
  input: {
    background: 'white',
  },
}));

const LeftPane = styled.div`
  background: linear-gradient(
    0deg,
    rgba(0, 75, 142, 1) 30%,
    rgba(0, 75, 142, 0.8239496482186625) 50%,
    rgba(0, 75, 142, 1) 70%
  );
  height: 100vh;
  width: 100%;
  align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const BankImg = styled.img`
  width: 70%;
`;

const RightPane = styled.div`
  background-color: lightgray;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FormContainer = styled.div`
  width: 35%;
`;

export default function Login() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, status, error, failedLogin } = useSelector(authSelector);
  const [viewPassword, setViewPassword] = useState(false);
  const { email, password } = loginModel;

  useEffect(() => {
    if (user.id) {
      history.push('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleSubmit = (values, formik) => {
    dispatch(login(values));
    formik.resetForm({
      values: {
        email: values.email,
        password: '',
      },
    });
  };

  const handleClickShowPassword = () => {
    setViewPassword(!viewPassword);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="stretch"
      xs={12}
    >
      <Grid item xs={4}>
        <LeftPane>
          <BankImg src={BankLogo} alt="Bank Logo" />
        </LeftPane>
      </Grid>
      <Grid item xs={8}>
        <RightPane>
          <Typography component="h1" variant="h5" gutterBottom align="left">
            Iniciar Sesión
          </Typography>
          <FormContainer>
            <Formik
              onSubmit={handleSubmit}
              initialValues={loginInitialState}
              validationSchema={loginValidationSchema}
            >
              {(formik) => (
                <Form>
                  <Box pt={3} pb={3}>
                    <Field
                      component={TextField}
                      name={email.name}
                      label={email.label}
                      required={email.required}
                      variant="filled"
                      fullWidth
                      type="email"
                      InputProps={{ className: classes.input }}
                    />
                  </Box>
                  <Box pt={3} pb={3}>
                    <Field
                      component={TextField}
                      name={password.name}
                      label={password.label}
                      required={password.required}
                      variant="filled"
                      fullWidth
                      type={viewPassword ? 'text' : 'password'}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            <IconButton>
                              {viewPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                        className: classes.input,
                        // autoComplete: 'off',
                      }}
                    />
                  </Box>
                  {(status === 'error' || failedLogin > 0) && (
                    <Typography variant="subtitle2" color="error">
                      Ha ocurrido un error al iniciar sesión. {error}
                    </Typography>
                  )}
                  <Box mt={3} mb={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={!formik.dirty || formik.isSubmitting}
                      fullWidth
                    >
                      Iniciar Sesión
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
            <Link href="#" variant="body2">
              Has olvidado tu contraseña?
            </Link>
          </FormContainer>
        </RightPane>
      </Grid>
    </Grid>
  );
}
